import { StaticImage } from "gatsby-plugin-image"
import { useState } from "react"

import { Heading, Icon, Tappable } from "@trueskin-web/components"
import { arrowLongRightIcon } from "@trueskin-web/theme/icons/arrowLongRightIcon"

import ProductDetailsDialog from "../../components/choose-plan/components/product-details-dialog"
import { products } from "../../components/choose-plan/resources"

const Product = ({ onClick, children, primary = false }) => (
  <Tappable
    onClick={onClick}
    sx={{
      mb: 2,
      p: 3,
      display: "flex",
      alignItems: "center",
      gap: 4,
      fontSize: 1,
      lineHeight: 1.5,
      border: "1px",
      borderStyle: primary ? "dashed" : "solid",
      borderRadius: "8px",
      borderColor: "#E1E1E1",
      cursor: "pointer",
      "&:hover, &:active": {
        background: "neutralsUltraLightGrey",
      },
    }}
  >
    {children}

    <Icon icon={arrowLongRightIcon} />
  </Tappable>
)

const Products = () => {
  const [dialogData, setDialogData] = useState(null)

  return (
    <>
      <Heading as="h3" size="sm" sx={{ mt: 6, mb: 4, fontWeight: "bold" }}>
        In Deinem Behandlungsplan enthalten
      </Heading>

      <Product
        onClick={() => setDialogData(products[0].details)}
        primary={true}
      >
        <StaticImage src="./images/formula_3x.webp" alt="" width={60} />
        <div sx={{ pr: 5 }}>
          <div sx={{ fontWeight: "bold", color: "text" }}>
            Personalisierte Formel
          </div>
          <div sx={{ color: "primaryLight" }}>
            Erstellt für Dich nach der ärztlichen Überprüfung Deiner Akte
          </div>
        </div>
      </Product>
      <Product onClick={() => setDialogData(products[1].details)}>
        <StaticImage src="./images/cleanser_3x.webp" alt="" width={60} />
        <div sx={{ pr: 5 }}>
          <div sx={{ fontWeight: "bold", color: "text" }}>Die Reinigung</div>
          <div sx={{ color: "textDark" }}>
            Befreit Deine Haut sanft von Talg, Schmutz und Make-up
          </div>
        </div>
      </Product>
      <Product onClick={() => setDialogData(products[2].details)}>
        <StaticImage src="./images/moisturizer_3x.webp" alt="" width={60} />
        <div sx={{ pr: 5 }}>
          <div sx={{ fontWeight: "bold", color: "text" }}>Die Pflege</div>
          <div sx={{ color: "textDark" }}>
            Beruhigt Deine Haut und spendet nötige Feuchtigkeit
          </div>
        </div>
      </Product>

      <ProductDetailsDialog
        {...dialogData}
        isOpen={Boolean(dialogData)}
        onDismiss={() => setDialogData(null)}
      />
    </>
  )
}

export default Products
